import fusionSpecialIceCream from './Ice Cream/Fusion Special Ice Cream.png'
import iceCreamWithBeries from './Ice Cream/Ice Cream with Beries.png'
import strawberySpecialIceCream from './Ice Cream/Strawberry Special.png'

let iceCreamItems = [
    {
        item_id: "23",
        item_name: "Fusion Special Ice Cream",
        item_image:fusionSpecialIceCream ,
        item_price:"1550",
        item_category: "icecream",
      },
      {
        item_id: "24",
        item_name: "Ice Cream with Beries",
        item_image: iceCreamWithBeries,
        item_price:"1350",
        item_category: "icecream",
      },
      {
        item_id: "25",
        item_name: "Strawberry Special",
        item_image:strawberySpecialIceCream ,
        item_price:"1750",
        item_category: "icecream",
      },
]

export default iceCreamItems